//#region src/lib/colorSchemes.ts
const colorSchemesTailwind = {
	purple: {
		background: "tw:new:bg-primary-lilac tw:bg-[#BEC0E4]",
		foreground: "tw:new:text-primary-purple tw:text-[#4D54B6]",
		border: "tw:new:border-primary-purple/10 tw:border-[#BEC0E4]"
	},
	mint: {
		background: "tw:new:bg-secondary-mint tw:bg-[#BEE4D2]",
		foreground: "tw:new:text-secondary-moss tw:text-[#4DB685]",
		border: "tw:new:border-secondary-moss/10 tw:border-[#BEE4D2]"
	},
	peach: {
		background: "tw:new:bg-secondary-peach tw:bg-[#E4BFBE]",
		foreground: "tw:new:text-secondary-clay tw:text-[#B64F4D]",
		border: "tw:new:border-secondary-clay/10 tw:border-[#E4BFBE]"
	},
	ivory: {
		background: "tw:new:bg-secondary-ivory tw:bg-[#E4E0BE]",
		foreground: "tw:new:text-secondary-sand tw:text-[#B6AB4D",
		border: "tw:new:border-secondary-sand/10 tw:border-[#E4E0BE]"
	}
};
const colorSchemesCSS = {
	purple: {
		background: "var(--color-primary-lilac)",
		foreground: "var(--color-primary-purple)",
		border: "var(--color-primary-purple-10)"
	},
	mint: {
		background: "var(--color-secondary-mint)",
		foreground: "var(--color-secondary-moss)",
		border: "var(--color-secondary-moss-10)"
	},
	peach: {
		background: "var(--color-secondary-peach)",
		foreground: "var(--color-secondary-clay)",
		border: "var(--color-secondary-clay-10)"
	},
	ivory: {
		background: "var(--color-secondary-ivory)",
		foreground: "var(--color-secondary-sand)",
		border: "var(--color-secondary-sand-10)"
	}
};
/**
* Generates a consistent color scheme based on user initials.
*
* @param initials - The user's initials (e.g., "JD" for John Doe)
* @param useTailwind - Whether to return Tailwind CSS classes (true) or CSS variable values (false)
* @returns A ColorScheme object with background, foreground, and border colors
*
* @example
* ```typescript
* const scheme = getColorScheme("JD", true);
* // Returns: { background: "tw:new:bg-primary-lilac", foreground: "tw:new:text-primary-purple", border: "tw:new:border-primary-purple/10" }
* ```
*/
const getColorScheme = (initials, useTailwind = true) => {
	const sum = initials.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
	const options = [
		"purple",
		"mint",
		"peach",
		"ivory"
	];
	const selectedOption = options[sum % options.length] || "purple";
	return useTailwind ? colorSchemesTailwind[selectedOption] : colorSchemesCSS[selectedOption];
};
const colorSchemes = {
	tailwind: colorSchemesTailwind,
	css: colorSchemesCSS
};
//#endregion
export { colorSchemes, getColorScheme };

//# sourceMappingURL=colorSchemes.js.map